import { Link } from "react-router-dom";
import { Navbar } from "../../../components/layout/Navbar";
import { Footer } from "../../../components/layout/Footer";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card";
import { Users, Briefcase } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";

const Register = () => {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{t('register.title')}</h1>
          <p className="text-muted-foreground text-lg">
            {t('register.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader className="text-center">
              <div className="mx-auto w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mb-4">
                <Users className="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <CardTitle>{t('register.investor.title')}</CardTitle>
              <CardDescription>
                {t('register.investor.description')}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-6 text-sm">
                {t('register.investor.details')}
              </p>
              <Button asChild className="w-full">
                <Link to="/investor-register">{t('register.investor.button')}</Link>
              </Button>
            </CardContent>
          </Card>

          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader className="text-center">
              <div className="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4">
                <Briefcase className="w-8 h-8 text-green-600 dark:text-green-400" />
              </div>
              <CardTitle>{t('register.projectHolder.title')}</CardTitle>
              <CardDescription>
                {t('register.projectHolder.description')}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-6 text-sm">
                {t('register.projectHolder.details')}
              </p>
              <Button asChild className="w-full" variant="outline">
                <Link to="/project-holder-register">{t('register.projectHolder.button')}</Link>
              </Button>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground">
            {t('register.signIn.text')}{" "}
            <Link to="/login" className="text-primary hover:underline">
              {t('register.signIn.link')}
            </Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Register;